import { NavLink, Outlet } from "react-router-dom";
import { trpc } from "@/lib/trpc";
import { cn } from "@/lib/utils";

type TemplatesSubTab = {
  to: string;
  label: string;
  count?: number;
};

export function SettingsTemplatesLayout() {
  const contractTemplatesQuery = trpc.contractTemplates.list.useQuery();
  const emailTemplatesQuery = trpc.emailTemplates.list.useQuery({ language: "lt" });

  const tabs: TemplatesSubTab[] = [
    {
      to: "/settings/templates/contract",
      label: "Contract templates",
      count: contractTemplatesQuery.data?.length,
    },
    {
      to: "/settings/templates/email",
      label: "Email templates",
      count: emailTemplatesQuery.data?.length,
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="mx-auto w-full max-w-screen-2xl px-4 pt-6 md:px-6">
        <nav aria-label="Templates sections" className="mb-2">
          <div className="flex flex-wrap items-center gap-2">
            {tabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                className={({ isActive }) =>
                  cn(
                    "flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-sm font-medium transition-colors",
                    isActive
                      ? "border-primary text-foreground"
                      : "border-border bg-background text-muted-foreground hover:bg-accent/50 hover:text-foreground"
                  )
                }
              >
                <span>{tab.label}</span>
                {tab.count ? (
                  <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-muted px-1.5 text-xs font-medium tabular-nums text-muted-foreground">
                    {tab.count}
                  </span>
                ) : null}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
